module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-verde.cc847751.svg";